import { Select } from '@99designs/common/components/Select';
import { Industry } from '__generated__/Industry';
import { handlePromise } from 'common/utils/Bugsnag';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import SummaryCardItem from 'projects/components/summary/SummaryCardItem';
import React from 'react';

interface Fields {
    industry: string;
}

interface SummaryProps {
    industry: string;
    industries: Industry[];
}

const title = __('What industry are you in?');

export function IndustryFieldSummary(props: SummaryProps) {
    const industry = props.industries.find(i => i.key === props.industry);
    if (!industry) {
        return null;
    }

    return <SummaryCardItem title={title}>{industry.title}</SummaryCardItem>;
}

interface EditProps<T> {
    form: ObservableForm<T>;
    industries: Industry[];
}

const IndustryField: <T extends Fields>(
    props: EditProps<T>
) => React.ReactElement<EditProps<T>> = ({ form, industries }) => {
    return (
        <Field
            form={form}
            name="industry"
            title={title}
            render={() => (
                <Select
                    name="industry"
                    options={[
                        { label: __('Select industry'), value: '', disabled: true },
                        ...industries
                            .sort((a, b) => a.title.localeCompare(b.title))
                            .map(({ key, title }) => ({ label: title, value: key })),
                    ]}
                    value={form.get('industry')}
                    onChange={({ value }: { value: string }) => {
                        handlePromise(form.set('industry', value), 'AboutYouPage');
                    }}
                    variations={['max']}
                />
            )}
        />
    );
};

export default IndustryField;
